import { Components } from 'react-markdown';
import { isExternalHref } from './agent-chat-utils';

// Answers link out to Slack messages, sources, etc. Open those in a new tab so clicking one doesn't
// navigate away from the page the chat is docked on (e.g. the activity feed).
export const AGENT_CHAT_MARKDOWN_COMPONENTS: Components = {
  a: ({ children, href, title }) => {
    if (!isExternalHref(href)) {
      return (
        <a href={href} title={title}>
          {children}
        </a>
      );
    }
    return (
      <a href={href} title={title} target='_blank' rel='noopener noreferrer'>
        {children}
        <span className='visually-hidden'> (opens in new tab)</span>
      </a>
    );
  }
};
